module.exports = __webpack_public_path__ + "static/media/bg_white_hills.c72a96a4.png";